import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import { TextLink } from '@sbt-web/ui';
import { ToggleDetails } from '@/client/components/Search/Elements/ToggleDetails';
import type { InternalLink } from './types';
import classes from './Footer.module.scss';
interface FooterProps {
  links: InternalLink[];
}
const Footer: FC<FooterProps> = t0 => {
  const $ = _c(5);
  const {
    links
  } = t0;
  if (links.length === 0) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2>Ricerche consigliate</h2>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== links) {
    t2 = links.map(_temp);
    $[1] = links;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <section data-google-interstitial="false" id="suggested-searches"><ToggleDetails summary={t1}><div className={classes.links}>{t2}</div></ToggleDetails></section>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default Footer;
function _temp(link) {
  return <TextLink key={link.href} href={link.href} weight="book" size="sm" themed={false} classes={[classes.link]}>{link.label}</TextLink>;
}